import { render } from "./SurveyQuestion6.vue?vue&type=template&id=112b04ca"
import script from "./SurveyQuestion6.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion6.vue?vue&type=script&lang=js"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__